     import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {MerchantMasterComponent} from './merchant-master/merchant-master.component';
import {RouterModule, Routes} from '@angular/router';
import {MerchantsComponent} from './merchants.component';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {NgSelectModule} from "@ng-select/ng-select";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  NgbAccordionModule, NgbAlertModule,
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbPaginationModule,
  NgbTimepickerModule,
  NgbTypeaheadModule
} from "@ng-bootstrap/ng-bootstrap";
import {AgGridModule} from "ag-grid-angular";
import {ApiHttpService} from "../../../_services/api-http.service";
import {HttpInterceptorProviders} from "../../../_helpers/http.interceptor";
import {MerchantAddComponent} from './merchant-master/merchant-add/merchant-add.component';
import {MerchantEditComponent} from './merchant-master/merchant-edit/merchant-edit.component';
import {MerchantListRoutingModule} from "./merchants-routing.module";
import {CustomCommonModule} from "../../../common/common.module";
import {ArchwizardModule} from "angular-archwizard";
import {FeatherIconModule} from '../../../core/feather-icon/feather-icon.module';
import {CoreInputsModule} from '../../../core/inputs/core-inputs.module';
import {MerchantService} from "./merchant-master/merchant.service";
import {MerchantBasicComponent} from './merchant-master/merchant-basic/merchant-basic.component';
import {MerchantKycUploadComponent} from './merchant-master/merchant-kyc-upload/merchant-kyc-upload.component';
import {MerchantCreationComponent} from './merchant-master/merchant-creation/merchant-creation.component';
import {SideNavService} from "../../layout/sidebar/side-name.service";
import {LayoutModule} from "../../layout/layout.module";
import {MerchantAccountListComponent} from './merchant-master/merchant-account-list/merchant-account-list.component';
import {MerchantMDRComponent} from "./merchant-master/merchant-mdr/merchant-mdr.component";
import {TwoDigitDecimaNumberDirective} from "./two-digit-decima-number.directive";
import {MerchantBlockedComponent} from "./merchant-master/merchant-blocked/merchant-blocked.component";
import {AlertService} from "../../../_services/alert.service";
import {MerchantstatusComponent} from './merchant-master/merchantstatus/merchantstatus.component';
import { PercentageDirective } from './percentage.directive';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {KycDocListComponent} from "./merchant-master/merchant-kyc-upload/kyc-doc-list/kyc-doc-list.component";
import { PepComponent } from '../pep/pep.component';
import { RiskRegisterComponent } from '../risk-register/risk-register.component';
import { MerchantReportComponent } from '../merchant-report/merchant-report.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MerchantScreeningComponent } from './merchant-master/merchant-screening/merchant-screening.component';
import { OnboardingComponent } from './merchant-master/onboarding/onboarding.component';
import { MerchantRemarkComponent } from './merchant-master/merchant-remark/merchant-remark.component';
import { MerchantConfigurationComponent } from './merchant-master/merchant-configuration/merchant-configuration.component';
import { DeviceManagementComponent } from './merchant-master/device-management/device-management.component';
import { MerchantContractGenerationComponent } from './merchant-contract-generation/merchant-contract-generation.component';
import { WalletRegistrationComponent } from './merchant-master/wallet-registration/wallet-registration.component';



@NgModule({
  declarations: [
    TwoDigitDecimaNumberDirective,
    MerchantMasterComponent,
    MerchantsComponent,
    MerchantAddComponent,
    MerchantEditComponent,
    MerchantBasicComponent,
    MerchantKycUploadComponent,
    MerchantCreationComponent,
    MerchantAccountListComponent,
    MerchantMDRComponent,
    MerchantBlockedComponent,
    MerchantstatusComponent,
    PercentageDirective,
    KycDocListComponent,
    PepComponent,
    RiskRegisterComponent,
    MerchantReportComponent,
    MerchantScreeningComponent,
    OnboardingComponent,
    MerchantRemarkComponent,
    MerchantConfigurationComponent,
    DeviceManagementComponent,
    MerchantContractGenerationComponent,
    WalletRegistrationComponent,

  ],
  imports: [
    CommonModule,
    MerchantListRoutingModule,
    NgxDatatableModule,
    NgSelectModule,
    FormsModule,
    NgbDropdownModule,
    NgbTypeaheadModule,
    AgGridModule,
    NgbPaginationModule,
    CustomCommonModule,
    ArchwizardModule,
    ReactiveFormsModule,
    FeatherIconModule,
    CoreInputsModule,
    NgbTimepickerModule,
     NgbNavModule,
    NgbCollapseModule,
    LayoutModule,
    NgbAccordionModule,
    NgbAlertModule,
    NgbModule,
    MatProgressBarModule,
    NgbModalModule
  ],
  exports: [MerchantBlockedComponent, MerchantstatusComponent, MerchantContractGenerationComponent],
  providers: [ApiHttpService,
     HttpInterceptorProviders,
     MerchantService, SideNavService, DatePipe, AlertService]
})
export class MerchantsModule {
}
